import { toBoolean } from 'pages/utils/sanitize';
import { setArchiveModalBypass } from 'root/apps/ItemArchiveModal';
import { setNewNuorderIntegrationModal } from 'root/apps/NuorderIntegrationModal';
import { setPrintedDocumentLanguages } from 'root/apps/PrintedDocumentLanguages';
import { setModalBypass } from 'root/apps/PurchaseOrder/ReceivedInventoryModal';
import { setOrderedStatusNuOrderModalBypass } from 'root/apps/PurchaseOrder/SendToNuorderModal';

const getNewDeferred = () => $.Deferred<AsyncHookResult, AsyncHookFailure, never>();

window.asyncHooks = window.asyncHooks || {};

window.asyncHooks.checkinReceivedPoFnc = function checkinReceivedPoFnc() {
  const deferred = getNewDeferred();
  setModalBypass({
    callback: (result) => {
      deferred.resolve(result ?? false);
    },
  });
  return deferred.promise();
};

window.asyncHooks.archiveItemFnc = function archiveItemFnc() {
  const deferred = getNewDeferred();
  setArchiveModalBypass({
    callback: (result) => {
      deferred.resolve(result ?? false);
    },
  });
  return deferred.promise();
};

window.asyncHooks.newNuorderVendorIntegrationHook = function () {
  const deferred = getNewDeferred();
  setNewNuorderIntegrationModal({
    callback: (result) => {
      deferred.resolve(result ?? false);
    },
  });
  return deferred.promise();
};

window.asyncHooks.poModeOrderedHook = function poModeOrderedHook() {
  const deferred = getNewDeferred();

  setOrderedStatusNuOrderModalBypass({
    callback: (result) => {
      deferred.resolve(result ?? false);
    },
  });

  return deferred.promise();
};

window.asyncHooks.printCurrentStatement = function printCurrentStatement() {
  const { printedDocumentLanguages } = window.merchantos.options;
  const deferred = getNewDeferred();
  if (printedDocumentLanguages.length === 1) {
    return deferred.resolve({ printed_document_language: printedDocumentLanguages[0] }).promise();
  }
  if (printedDocumentLanguages.length > 1) {
    setPrintedDocumentLanguages({
      callback: (language) => {
        deferred.resolve({ printed_document_language: language });
      },
    });
  }
  return deferred.promise();
};

window.asyncHooks.savePurchaseOrder = function savePurchaseOrder(pannel) {
  const deferred = getNewDeferred();
  const message = `The unit cost of items still on order will be updated. Unit cost of items received will not be updated. This will cause discrepancies in your costs. Are you sure you want to update all items unit cost in the PO?`;
  const selectedValue = (document.getElementById('purchase_mode_select') as HTMLSelectElement)
    ?.value;

  window.fillViewKeyValues(pannel);

  const triggerContext = (document.getElementById('save_trigger_context') as HTMLInputElement)
    ?.value;
  if (triggerContext === 'apply_changes') {
    return deferred.resolve(true).promise();
  }

  if (pannel.key_values?.has_shipments && toBoolean(pannel.key_values.has_shipments)) {
    if (window.checkPannelForChanges('po_cost_field_group')) {
      if (!window.confirm(message)) {
        return deferred.resolve(false).promise();
      }
    }
  }

  const reviewBtn = document.getElementById('review_nuorder_po_btn');

  if (selectedValue === 'ordered' && reviewBtn && !reviewBtn.classList.contains('hidden')) {
    setOrderedStatusNuOrderModalBypass({
      callback: (result) => {
        deferred.resolve(result ?? false);
      },
    });

    return deferred.promise();
  }

  return deferred.resolve(true).promise();
};
